import React, { useState } from 'react';
import classnames from 'classnames';
import styles from '../editContactModal.module.scss';
import { FormControl } from 'react-bootstrap';
import { ContactFormProps, User } from 'v2/models';
import FormLabel from 'v2/form/FormLabel/FormLabel';
import OwnersSelect from 'v2/form/CustomSelectors/OwnersSelect';
import { useTranslation } from 'react-i18next';
import { TranslationKeys } from 'translations';

const ContactOwnerForm = ({
  register,
  setValue: setValueContactOwner,
  contactOwner,
}: ContactFormProps) => {
  const { t } = useTranslation();
  const [currentOwner, setCurrentOwner] = useState<User | undefined>(
    contactOwner
  );

  function handleChange(option: User | undefined) {
    setCurrentOwner(option);
    setValueContactOwner?.('contact_owner', Number(option?.id), {
      shouldValidate: true,
    });
  }

  return (
    <div className={classnames(styles.descriptionForm, 'mt-2')}>
      <span className={classnames(styles.titleDescription, 'mb-3')}>
        Designate an owner for this {t(TranslationKeys.contact_one)}
      </span>
      <FormLabel label={`Owner Name`} required={false} />
      <div data-cy="contact-details:contact-owner-modal-owner-select">
        <OwnersSelect owner={contactOwner} onChange={handleChange} />
      </div>
      <FormLabel label={`Title`} required={false} className="mt-3" />
      <FormControl
        type="text"
        autoComplete="off"
        readOnly={true}
        aria-label="contact-jobtitle-input"
        data-cy="contact-details:contact-owner-modal-title"
        value={currentOwner?.job_title}
      />
      <FormLabel label={`Email Address`} required={false} className="mt-3" />
      <FormControl
        type="text"
        autoComplete="off"
        readOnly={true}
        aria-label="contact-email-input"
        data-cy="contact-details:contact-owner-modal-email"
        value={currentOwner?.email}
      />
      <FormControl
        type="hidden"
        readOnly={true}
        aria-label="contact-hidden-input"
        {...register?.('contact_owner', {
          required: true,
          validate: (value) => contactOwner?.id !== value,
        })}
      />
    </div>
  );
};

export default ContactOwnerForm;
